export default {
  articles: [],
  defaults: {},
  comments: [],
  reportedComments: [],
  reportedContent: [],
  userContent: [],
  viewArticle: {}
};
